module.exports = __webpack_public_path__ + "img/image30.7f0b9430.jpeg";